import { useQueryClient } from '@tanstack/react-query';
import {
  CalendarRoles,
  isAbleToSeeUIElement,
} from '../../../utils/roles/client-roles';
import { UserKeys } from '../../../api/users-api';
import SharedToolbar from '../../../shared/shared-toolbar-latest';
import SharedGridStateIconButton from '../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../shared/analytics/module-list';
import { useNavigate } from 'react-router-dom';
import { pagesConfig } from '../../../shared/pages-config';
import CreateButton from '../../../shared/buttons/create-button';
import SharedIconButton from '../../../shared/buttons/shared-icon-button';

interface ResourceTemplatesGridToolbarProps {
  calendarRoles: string[];
}

export default function ResourceTemplatesGridToolbar({
  calendarRoles,
}: ResourceTemplatesGridToolbarProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          disabled={
            !isAbleToSeeUIElement(
              calendarRoles,
              CalendarRoles.CreateResourceTemplate.value
            )
          }
          onClick={() =>
            navigate(
              `/${pagesConfig.resourceTemplates.link}/${pagesConfig.createResourceTemplate.link}`
            )
          }
          label="Create Resource Template"
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              queryClient.invalidateQueries({
                queryKey: [UserKeys.CalendarResourceTemplates],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="resourceTemplatesGridStates"
            module={ModuleList.modules.calendars.name}
            section={ModuleList.modules.calendars.sections.resourceTemplates}
          />
        </>
      }
    />
  );
}
